
import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Grid,
  } from "@mui/material";
import { FIELD_HEADING } from "../shared/constants";
import { formatDateTime } from "../shared/utils";

const UserDetails = ({ userData }) => {
  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ borderTop: "2px solid #005CFF" }}>
            <TableRow>
              {[
               FIELD_HEADING.LAST_RECEIPT,
               FIELD_HEADING.STATUS,
               FIELD_HEADING.NAME,
               FIELD_HEADING.PHONE,
               FIELD_HEADING.DUE_DATE,
               FIELD_HEADING.GESTATIONAL_AGE,
               FIELD_HEADING.DATE_REG,
               FIELD_HEADING.SMS_SENT,
              ].map((header) => (
                <TableCell key={header} sx={{ fontWeight: "bold" }}>
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow sx={{ background: "#eeeeee" }}>
              <TableCell>{formatDateTime(userData.lastReceipt)}</TableCell>
              <TableCell>{userData.status}</TableCell>
              <TableCell>{userData.name}</TableCell>
              <TableCell>{userData.phone}</TableCell>
              <TableCell>{userData.dueDate}</TableCell>
              <TableCell>{userData.gestationalAge}</TableCell>
              <TableCell>{userData.dateRegistered}</TableCell>
              <TableCell>{userData.smsSent}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default UserDetails;
